import BaseAPI, { MAX_LIST_LIMIT } from "./BaseAPI";
import { trainingCourseRoute } from "../routes";

export default class TrainingCourseAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, trainingCourseRoute, "training-course");
    }

    async List(params = {}) {
        return super.List({ limit: MAX_LIST_LIMIT, ...params });
    }
}
